import React from 'react';
import styled from '@emotion/styled';
import * as colors from '../../styles/colors';

const InputStyled = styled.input`
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  border: 1px solid #dcd6e8;
  background: #ffffff;
  padding: 12px 14px;
  outline: none;
  font-size: 14px;
  color: ${colors.textMain};
  font-family: inherit;
  transition: 0.2s ease;

  &:focus {
    border-color: #bbaaf6;
    box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);
  }

  &::placeholder {
    color: ${colors.textSoft};
  }

  &:disabled {
    background: #f9f8fd;
    cursor: not-allowed;
  }
`;

const TextareaStyled = styled.textarea`
  width: 100%;
  min-height: 110px;
  border-radius: 14px;
  border: 1px solid #dcd6e8;
  background: #ffffff;
  padding: 12px 14px;
  outline: none;
  font-size: 14px;
  color: ${colors.textMain};
  font-family: inherit;
  resize: vertical;
  transition: 0.2s ease;

  &:focus {
    border-color: #bbaaf6;
    box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);
  }

  &::placeholder {
    color: ${colors.textSoft};
  }

  &:disabled {
    background: #f9f8fd;
    cursor: not-allowed;
  }
`;

const SelectStyled = styled.select`
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  border: 1px solid #dcd6e8;
  background: #ffffff;
  padding: 12px 14px;
  outline: none;
  font-size: 14px;
  color: ${colors.textMain};
  font-family: inherit;
  transition: 0.2s ease;

  &:focus {
    border-color: #bbaaf6;
    box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);
  }

  &:disabled {
    background: #f9f8fd;
    cursor: not-allowed;
  }
`;

export const ZfInput = (props) => <InputStyled {...props} />;
export const ZfTextarea = (props) => <TextareaStyled {...props} />;
export const ZfSelect = (props) => <SelectStyled {...props} />;

export default ZfInput;
